import { Grid, Typography, Button, IconButton, Checkbox, FormControlLabel } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import React, { useEffect, useState, useRef } from 'react';
import CardSecondaryAction from '../../ui-component/cards/CardSecondaryAction';
import MainCard from '../../ui-component/cards/MainCard';
import { gridSpacing } from '../../store/constant';
import { Label } from 'reactstrap';
import { Divider, ListItemIcon } from '@mui/material';
import axiosInstance from '../../axiosInstance';
import { useForm, Controller, SubmitHandler, useFieldArray } from 'react-hook-form';
// import icons from '../../menu-items/menuIcon';
import { useSelector, useDispatch } from 'react-redux';
import { isOwnerAccount } from '../../insight-hub/lib/access';
import configData from '../../config';
import { REPORT_DATA_ADDED } from '../../store/actions';
import MaterialTable from '@material-table/core';
import { IconListDetails, IconPlus, IconEdit, IconTrashX, IconSquareRoundedX } from '@tabler/icons';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
import EditModal from './EditModal';

const icons = {
    IconListDetails,
    IconPlus,
    IconEdit,
    IconTrashX,
    IconSquareRoundedX
};

const columns = [
    {
        title: 'Report Name',
        field: 'title',
        render: (rowData) => {
            const displayTitle = rowData.title || 'Untitled report';

            return (
                <span style={{ fontWeight: rowData.isChild === false ? 700 : 500, color: '#071a2d' }}>
                    {displayTitle}
                </span>
            );
        }
    },
    {
        title: 'Group Type',
        field: 'parent',
        render: (rowData) => (
            <span style={{ color: '#536866' }}>{rowData.parent || (rowData.isChild ? 'Child report' : 'Primary report')}</span>
        )
    },
    {
        title: 'Power BI URL',
        field: 'embedURL',
        render: (rowData) => {
            const displayURL = rowData.embedURL || '';

            return (
                <span
                    title={displayURL}
                    style={{
                        display: 'block',
                        maxWidth: 420,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        color: '#536866'
                    }}
                >
                    {displayURL || 'Not configured'}
                </span>
            );
        }
    }
];

const reportType = ['collapse', 'item'];

function AccessAndManageReports() {
    const [reportType, setReportType] = useState('');
    const [company, setCompany] = useState();
    const [companyName, setCompanyName] = useState();
    const [selectCompany, setSelectCompany] = useState(false);
    const [loading, setLoading] = useState(false);
    const [tableRowData, setTableRowData] = useState();
    const [row_data, setRowData] = useState();
    const [apiData, setAPIData] = useState([]);
    const [modal, setModal] = useState(false);
    const [editModal, setEditModal] = useState(false);
    const [editdeleteModal, setDeleteModal] = useState(false);
    const [singleReportData, setSingleReportData] = useState();
    const [isSecureReport, setIsSecureReport] = useState(false);
    const dispatch = useDispatch();
    const account = useSelector((state) => state.account || {});
    const isOwner = isOwnerAccount(account);

    const toggle = () => {
        setModal(!modal);
        setIsSecureReport(false); // Reset secure report checkbox when modal is closed
    };

    const toggleEditModal = () => setEditModal(!editModal);
    const toggleDeleteModal = () => setDeleteModal(!editdeleteModal);

    const handleSecureReportChange = (event) => {
        setIsSecureReport(event.target.checked);
    };

    const actions = [
        {
            icon: icons.IconEdit,
            tooltip: 'Edit Reports',
            // iconProps: { style: { color: 'green' } },
            onClick: async (event, rowData) => {
                setTableRowData(rowData);
                toggleEditModal();
            }
        },
        {
            icon: icons.IconTrashX,
            tooltip: 'Delete Reports',
            iconProps: { style: { color: '#f15e5e' } },
            onClick: async (event, rowData) => {
                console.log(rowData.id);
                try {
                    setRowData(rowData);
                } catch (error) {
                    console.log(error);
                }
            }
        }
    ];

    const {
        control,
        register,
        handleSubmit,
        watch,
        formState: { errors },
        setValue
    } = useForm({
        defaultValues: {
            children: [
                {
                    sub_report_name: '',
                    powerbi_url: ''
                }
            ],
            reportId: '',
            datasetId: '',
            rlsRole: '',
            groupId: ''
        }
    });

    const {
        fields: children,
        append: appendChildren,
        remove: removeChildren
    } = useFieldArray({
        control,
        name: 'children'
    });

    const addChildren = () => {
        appendChildren({
            sub_report_name: '',
            powerbi_url: ''
        });
    };

    const updateGroupType = (e) => {
        console.log(e.target.value);
        setReportType(e.target.value);
    };

    const generateReportId = (reportName) => {
        // Remove spaces and convert to lowercase for a clean ID
        const cleanReportName = reportName.replace(/\s/g, '').toLowerCase();

        // Generate a random 6-digit number
        const randomDigits = Math.floor(100000 + Math.random() * 900000);

        // Combine the cleaned report name and random digits to form the ID
        const reportId = `${cleanReportName}_${randomDigits}`;

        return reportId;
    };

    const onSubmit = async (data) => {
        console.log(data);
        // return;
        console.log('Data>>>>>', data);
        const mainReportData = [];
        const id = generateReportId(data.report_name);
        if (data.type === 'item') {
            const singleReport = {};
            // console.log(id);
            singleReport.id = id;
            singleReport.url = '/power-bi-report-page';
            singleReport.title = data.report_name;
            singleReport.embedURL = data.powerbi_url;
            singleReport.type = data.type;
            singleReport.breadcrumbs = false;
            singleReport.parent_id = null;
            singleReport.isChild = false;
            
            // Add secure report fields if checked
            if (isSecureReport) {
                singleReport.reportId = data.reportId;
                singleReport.datasetId = data.datasetId;
                singleReport.rlsRole = data.rlsRole;
                singleReport.groupId = data.groupId;
                singleReport.isSecure = true;
            }
            
            mainReportData.push(singleReport);
            console.log('mainReportData+++++>>>>>', mainReportData);
        } else if (data.type === 'collapse') {
            const singleReport = {};
            // console.log('data++++>>>', data);
            singleReport.id = id;
            singleReport.title = data.report_name;
            singleReport.type = data.type;
            singleReport.breadcrumbs = false;
            singleReport.children = [];
            singleReport.isChild = false;
            singleReport.parent_id = null;

            mainReportData.push(singleReport);

            // Check if 'children' array exists in the data
            if (data.children && Array.isArray(data.children)) {
                // singleReport.children = [];
                // Loop through the 'children' array and add each item to singleReport.children
                data.children.forEach((child) => {
                    const subReport = {
                        id: generateReportId(child.sub_report_name),
                        title: child.sub_report_name,
                        type: 'item',
                        url: '/power-bi-report-page',
                        embedURL: child.powerbi_url,
                        breadcrumbs: false,
                        parent_id: id,
                        isChild: true
                    };
                    mainReportData.push(subReport);
                });
            }
            console.log('GROUP REPORT++>>', mainReportData);
        }

        // const res = await axiosInstance.post('http://127.0.0.1:8000/user/create_reports', mainReportData);
        const res = await axiosInstance.post(configData.API_SERVER + '/user/create_reports', mainReportData);
        console.log(res);
        await getReportList();
        dispatch({ type: REPORT_DATA_ADDED, payload: res.data });
        alert('Report Created Successfully');
        toggle();
    };

    const getReportList = async () => {
        try {
            // const response = await axiosInstance.get(`http://127.0.0.1:8000/user/get_reports`);
            const response = await axiosInstance.get(configData.API_SERVER +  `/user/get_reports`);
            setAPIData(response?.data ? response?.data : []);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        const fetchCompany = async () => {
            try {
                const response = await axiosInstance.get(configData.API_SERVER + '/organization/get_org');
                // const response = await axiosInstance.get('http://127.0.0.1:8000/organization/get_org');
                setCompany(response.data);
            } catch (error) {
                console.log(error);
            }
        };

        getReportList();
        fetchCompany();
    }, []);

    const TableData = apiData;

    useEffect(() => {
        if (row_data) toggleDeleteModal();
    }, [row_data]);

    const deleteReport = async () => {
        try {
            const res = await axiosInstance.delete(configData.API_SERVER +  `/user/delete_report_by_id?report_id=${row_data.id}`);
            // const res = await axiosInstance.delete(`http://127.0.0.1:8000/user/delete_report_by_id?report_id=${row_data.id}`);
            console.log(res);
            if(res.status){
                getReportList();
                toggleDeleteModal();
                setRowData();
            }
        } catch (error) {
            console.log(error);
        }
    };

    const totalReports = Array.isArray(TableData) ? TableData.length : 0;
    const groupedReports = Array.isArray(TableData) ? TableData.filter((report) => report.type === 'collapse').length : 0;
    const secureReports = Array.isArray(TableData) ? TableData.filter((report) => report.isSecure).length : 0;

    return (
        <React.Fragment>
            {isOwner && (
                <div className="grid gap-5 text-[#071a2d]">
                    <section className="surface-card p-5 lg:p-6">
                        <div className="flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between">
                            <div>
                                <p className="text-[11px] font-semibold uppercase tracking-[0.22em] text-primary">Owner Workspace</p>
                                <h2 className="mt-2 text-2xl font-semibold tracking-normal text-[#071a2d]">Reports Management</h2>
                                <p className="mt-1 max-w-2xl text-sm text-muted-foreground">
                                    Create, update, and remove embedded Power BI report entries without changing allocation rules.
                                </p>
                            </div>
                            <Button
                                variant="contained"
                                endIcon={<IconPlus />}
                                onClick={toggle}
                                style={{
                                    minHeight: 40,
                                    borderRadius: 8,
                                    backgroundColor: '#00a174',
                                    boxShadow: 'none',
                                    color: '#fff',
                                    fontWeight: 700,
                                    textTransform: 'none'
                                }}
                            >
                                Create New Report
                            </Button>
                        </div>

                        <div className="mt-5 grid grid-cols-1 gap-3 md:grid-cols-3">
                            {[
                                ['Total Reports', totalReports],
                                ['Grouped Reports', groupedReports],
                                ['Secure Reports', secureReports]
                            ].map(([label, value]) => (
                                <div key={label} className="rounded-lg border border-border bg-white px-4 py-3">
                                    <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-muted-foreground">{label}</p>
                                    <p className="mt-2 text-2xl font-semibold text-[#071a2d]">{value}</p>
                                </div>
                            ))}
                        </div>
                    </section>

                    <section className="surface-card overflow-hidden">
                        <div className="border-b border-border px-5 py-4">
                            <p className="text-[11px] font-semibold uppercase tracking-[0.22em] text-primary">Report Library</p>
                            <h3 className="mt-1 text-lg font-semibold text-[#071a2d]">Embedded Reports</h3>
                        </div>
                        <div className="overflow-x-auto p-4">
                            <div className="min-w-[720px] rounded-lg border border-border">
                                <MaterialTable
                                    style={{
                                        width: '100%',
                                        borderRadius: 8,
                                        boxShadow: 'none',
                                        overflow: 'hidden',
                                        fontFamily: 'inherit'
                                    }}
                                    actions={actions}
                                    isLoading={loading}
                                    title=""
                                    columns={columns}
                                    data={TableData}
                                    options={{
                                        pageSize: 10,
                                        actionsColumnIndex: -1,
                                        search: false,
                                        grouping: false,
                                        columnsButton: false,
                                        paging: true,
                                        showFirstLastPageButtons: false,
                                        filtering: false,
                                        toolbar: false,
                                        headerStyle: {
                                            backgroundColor: '#f8faf9',
                                            color: '#536866',
                                            height: '48px',
                                            textAlign: 'left',
                                            fontSize: '11px',
                                            fontWeight: 700,
                                            letterSpacing: '0.14em',
                                            textTransform: 'uppercase',
                                            borderBottom: '1px solid #e1e7e5'
                                        },
                                        cellStyle: {
                                            textAlign: 'left',
                                            color: '#071a2d',
                                            minHeight: '48px',
                                            fontSize: '14px',
                                            borderBottom: '1px solid #eef2f1'
                                        },
                                        rowStyle: {
                                            backgroundColor: '#fff'
                                        }
                                    }}
                                />
                            </div>
                        </div>
                    </section>

                    <>
                        <Modal isOpen={modal} toggle={toggle} backdrop={true} centered={true} size="lg">
                            <ModalHeader toggle={toggle}>Create Reports</ModalHeader>
                            <ModalBody style={{ maxHeight: '74vh', overflowY: 'auto' }}>
                                <Grid container spacing={2} style={{ marginTop: '0px' }}>
                                    <form onSubmit={handleSubmit(onSubmit)} style={{ width: '100%' }}>
                                        <Grid container spacing={gridSpacing} style={{ padding: '10px' }}>
                                            <Grid item lg={12} sm={12} md={12} className="al_sl__main_grid1" style={{ flexWrap: 'wrap' }}>
                                                <Grid item lg={2} md={2} sm={12} className="sad_Single">
                                                    <Label style={{ fontSize: '14px !important' }}>
                                                        Report Name/Report Group<span style={{ color: 'red' }}>*</span>
                                                    </Label>
                                                </Grid>
                                                <Grid item lg={5} md={5} sm={12} className="sad_Single">
                                                    <input
                                                        className="form-control "
                                                        placeholder="Report Name"
                                                        style={{ width: '90% !important', marginBottom: '1.3vh' }}
                                                        {...register('report_name', { required: 'Report Name Is Required' })}
                                                    />
                                                    {errors.report_name && (
                                                        <p style={{ color: '#dc3545e6', fontSize: '13px', marginTop: '-1px' }}>
                                                            {errors.report_name.message}
                                                        </p>
                                                    )}
                                                </Grid>
                                                <Grid item lg={5} md={5} sm={12} className="sad_Single"></Grid>
                                                <Grid item lg={2} md={2} sm={12} className="sad_Single">
                                                    <Label style={{ fontSize: '14px !important' }}>
                                                        Report Type<span style={{ color: 'red' }}>*</span>
                                                    </Label>
                                                </Grid>
                                                <Grid item lg={5} md={5} sm={12} className="sad_Single">
                                                    <select
                                                        className="form-select "
                                                        style={{ cursor: 'pointer' }}
                                                        {...register('type', { required: 'Please Select Report Type' })}
                                                        onChange={updateGroupType}
                                                    >
                                                        <option value="" style={{ color: 'gray' }}>
                                                            Select Report Type
                                                        </option>
                                                        <option value="collapse" style={{ color: 'gray' }}>
                                                            Group Reports
                                                        </option>
                                                        <option value="item" style={{ color: 'gray' }}>
                                                            Single Report
                                                        </option>
                                                    </select>
                                                    {errors.type && (
                                                        <p style={{ color: '#dc3545e6', fontSize: '13px' }}>{errors.type.message}</p>
                                                    )}
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        {/* Secure Report Checkbox and Fields */}
                                        <Grid container spacing={gridSpacing} style={{ padding: '10px' }}>
                                            <Grid item lg={12} sm={12} md={12} className="al_sl__main_grid1" style={{ flexWrap: 'wrap' }}>
                                                <Grid item lg={2} md={2} sm={12} className="sad_Single">
                                                    <Label style={{ fontSize: '14px !important' }}>Secure Report</Label>
                                                </Grid>
                                                <Grid item lg={5} md={5} sm={12} className="sad_Single">
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                checked={isSecureReport}
                                                                onChange={handleSecureReportChange}
                                                                color="primary"
                                                            />
                                                        }
                                                        label="Enable RLS (Row Level Security)"
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        {isSecureReport && (
                                            <>
                                                <Grid container spacing={gridSpacing} style={{ padding: '10px' }}>
                                                    <Grid item lg={12} sm={12} md={12} className="al_sl__main_grid1" style={{ flexWrap: 'wrap' }}>
                                                        <Grid item lg={2} md={2} sm={12} className="sad_Single">
                                                            <Label style={{ fontSize: '14px !important' }}>
                                                                Report ID<span style={{ color: 'red' }}>*</span>
                                                            </Label>
                                                        </Grid>
                                                        <Grid item lg={5} md={5} sm={12} className="sad_Single">
                                                            <input
                                                                className="form-control "
                                                                placeholder="Report ID"
                                                                style={{ width: '90% !important', marginBottom: '1.3vh' }}
                                                                {...register('reportId', { required: isSecureReport ? 'Report ID is required' : false })}
                                                            />
                                                            {errors.reportId && (
                                                                <p style={{ color: '#dc3545e6', fontSize: '13px', marginTop: '-1px' }}>
                                                                    {errors.reportId.message}
                                                                </p>
                                                            )}
                                                        </Grid>
                                                    </Grid>
                                                </Grid>

                                                <Grid container spacing={gridSpacing} style={{ padding: '10px' }}>
                                                    <Grid item lg={12} sm={12} md={12} className="al_sl__main_grid1" style={{ flexWrap: 'wrap' }}>
                                                        <Grid item lg={2} md={2} sm={12} className="sad_Single">
                                                            <Label style={{ fontSize: '14px !important' }}>
                                                                Dataset ID<span style={{ color: 'red' }}>*</span>
                                                            </Label>
                                                        </Grid>
                                                        <Grid item lg={5} md={5} sm={12} className="sad_Single">
                                                            <input
                                                                className="form-control "
                                                                placeholder="Dataset ID"
                                                                style={{ width: '90% !important', marginBottom: '1.3vh' }}
                                                                {...register('datasetId', { required: isSecureReport ? 'Dataset ID is required' : false })}
                                                            />
                                                            {errors.datasetId && (
                                                                <p style={{ color: '#dc3545e6', fontSize: '13px', marginTop: '-1px' }}>
                                                                    {errors.datasetId.message}
                                                                </p>
                                                            )}
                                                        </Grid>
                                                    </Grid>
                                                </Grid>

                                                <Grid container spacing={gridSpacing} style={{ padding: '10px' }}>
                                                    <Grid item lg={12} sm={12} md={12} className="al_sl__main_grid1" style={{ flexWrap: 'wrap' }}>
                                                        <Grid item lg={2} md={2} sm={12} className="sad_Single">
                                                            <Label style={{ fontSize: '14px !important' }}>
                                                                RLS Role<span style={{ color: 'red' }}>*</span>
                                                            </Label>
                                                        </Grid>
                                                        <Grid item lg={5} md={5} sm={12} className="sad_Single">
                                                            <input
                                                                className="form-control "
                                                                placeholder="RLS Role"
                                                                style={{ width: '90% !important', marginBottom: '1.3vh' }}
                                                                {...register('rlsRole', { required: isSecureReport ? 'RLS Role is required' : false })}
                                                            />
                                                            {errors.rlsRole && (
                                                                <p style={{ color: '#dc3545e6', fontSize: '13px', marginTop: '-1px' }}>
                                                                    {errors.rlsRole.message}
                                                                </p>
                                                            )}
                                                        </Grid>
                                                    </Grid>
                                                </Grid>

                                                <Grid container spacing={gridSpacing} style={{ padding: '10px' }}>
                                                    <Grid item lg={12} sm={12} md={12} className="al_sl__main_grid1" style={{ flexWrap: 'wrap' }}>
                                                        <Grid item lg={2} md={2} sm={12} className="sad_Single">
                                                            <Label style={{ fontSize: '14px !important' }}>
                                                                Group ID<span style={{ color: 'red' }}>*</span>
                                                            </Label>
                                                        </Grid>
                                                        <Grid item lg={5} md={5} sm={12} className="sad_Single">
                                                            <input
                                                                className="form-control "
                                                                placeholder="Group ID"
                                                                style={{ width: '90% !important', marginBottom: '1.3vh' }}
                                                                {...register('groupId', { required: isSecureReport ? 'Group ID is required' : false })}
                                                            />
                                                            {errors.groupId && (
                                                                <p style={{ color: '#dc3545e6', fontSize: '13px', marginTop: '-1px' }}>
                                                                    {errors.groupId.message}
                                                                </p>
                                                            )}
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </>
                                        )}

                                        {reportType === 'collapse' ? (
                                            <>
                                                {children.map((item, index) => (
                                                    <div key={index}>
                                                        <Divider />
                                                        <Grid container spacing={gridSpacing} style={{ padding: '10px' }}>
                                                            <Grid
                                                                item
                                                                lg={12}
                                                                sm={12}
                                                                md={12}
                                                                className="al_sl__main_grid1"
                                                                style={{ flexWrap: 'wrap' }}
                                                            >
                                                                <Grid item lg={2} md={2} sm={12} className="sad_Single">
                                                                    <Label style={{ fontSize: '14px !important' }}>
                                                                        Report Name/Report Group<span style={{ color: 'red' }}>*</span>
                                                                    </Label>
                                                                </Grid>
                                                                <Grid item lg={5} md={5} sm={12} className="sad_Single">
                                                                    <input
                                                                        className="form-control "
                                                                        placeholder="Report Name"
                                                                        style={{ width: '90% !important', marginBottom: '1.3vh' }}
                                                                        {...register(`children.${index}.sub_report_name`, {
                                                                            required: 'Report Name Is Required'
                                                                        })}
                                                                    />
                                                                    {errors?.children?.[index]?.sub_report_name && (
                                                                        <p
                                                                            style={{
                                                                                color: '#dc3545e6',
                                                                                fontSize: '13px',
                                                                                marginTop: '-1px'
                                                                            }}
                                                                        >
                                                                            {errors.children[index].sub_report_name.message}
                                                                        </p>
                                                                    )}
                                                                </Grid>
                                                                <Grid item lg={5} md={5} sm={12} className="sad_Single"></Grid>
                                                                <Grid item lg={2} md={2} sm={12} className="sad_Single">
                                                                    <Label style={{ fontSize: '14px !important' }}>
                                                                        Report PowerBI URL<span style={{ color: 'red' }}>*</span>
                                                                    </Label>
                                                                </Grid>
                                                                <Grid item lg={5} md={5} sm={12} className="sad_Single">
                                                                    <input
                                                                        className="form-control "
                                                                        placeholder="Report URL"
                                                                        style={{ width: '90% !important', marginBottom: '1.3vh' }}
                                                                        {...register(`children.${index}.powerbi_url`, {
                                                                            required: 'Url is required Is Required'
                                                                        })}
                                                                    />
                                                                    {errors?.children?.[index]?.powerbi_url && (
                                                                        <p
                                                                            style={{
                                                                                color: '#dc3545e6',
                                                                                fontSize: '13px',
                                                                                marginTop: '-1px'
                                                                            }}
                                                                        >
                                                                            {errors.children[index].powerbi_url.message}
                                                                        </p>
                                                                    )}
                                                                </Grid>
                                                            </Grid>
                                                            <div
                                                                style={{
                                                                    width: '97%',
                                                                    display: 'flex',
                                                                    alignItems: 'end',
                                                                    justifyContent: 'end'
                                                                }}
                                                            >
                                                                {/* <IconButton aria-label="delete" color="error">
                                                                    <DeleteIcon />
                                                                </IconButton> */}
                                                            </div>
                                                        </Grid>
                                                    </div>
                                                ))}
                                                <Button style={{ marginLeft: '15px', marginTop: '10px' }} onClick={addChildren}>
                                                    Add More Reports
                                                </Button>
                                            </>
                                        ) : reportType === 'item' ? (
                                            <>
                                                <Grid container spacing={gridSpacing} style={{ padding: '10px' }}>
                                                    <Grid
                                                        item
                                                        lg={12}
                                                        sm={12}
                                                        md={12}
                                                        className="al_sl__main_grid1"
                                                        style={{ flexWrap: 'wrap' }}
                                                    >
                                                        <Grid item lg={2} md={2} sm={12} className="sad_Single">
                                                            <Label style={{ fontSize: '14px !important' }}>
                                                                Report PowerBI URL<span style={{ color: 'red' }}>*</span>
                                                            </Label>
                                                        </Grid>
                                                        <Grid item lg={5} md={5} sm={12} className="sad_Single">
                                                            <input
                                                                className="form-control "
                                                                placeholder="Report URL"
                                                                style={{ width: '90% !important', marginBottom: '1.3vh' }}
                                                                {...register('powerbi_url', { required: 'Url is required Is Required' })}
                                                            />
                                                            {errors.powerbi_url && (
                                                                <p style={{ color: '#dc3545e6', fontSize: '13px', marginTop: '-1px' }}>
                                                                    {errors.powerbi_url.message}
                                                                </p>
                                                            )}
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </>
                                        ) : reportType === '' ? (
                                            <></>
                                        ) : (
                                            <></>
                                        )}

                                        <Grid item lg={12} sm={12} md={12} className="al_sl__main_grid" style={{ marginTop: '-2rem' }}>
                                            <Grid item lg={4} sm={6}>
                                                <br></br>
                                                <Button
                                                    type="submit"
                                                    variant="outlined"
                                                    style={{ marginLeft: '15px', marginTop: '10px' }}
                                                    onClick={(e) => {
                                                        handleSubmit(onSubmit);
                                                        // onSubmit();
                                                        // e.preventDefault();
                                                    }}
                                                >
                                                    Save Details
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </form>
                                </Grid>
                            </ModalBody>
                        </Modal>
                    </>

                    <Modal isOpen={editdeleteModal} toggle={toggleDeleteModal} backdrop={true} centered={true} size="md">
                        <ModalBody>
                            <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <IconSquareRoundedX color="#f15e5e" size="76px" style={{ fontSize: '46px' }} />
                            </div>
                            <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <h2 style={{ color: '#636363' }}>Are you sure?</h2>
                            </div>
                            <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <p style={{ color: '#999', textAlign: 'center', width: '70%' }}>
                                    Do you really want to delete these records? This process cannot be undone.
                                </p>
                            </div>
                            <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <Button
                                    type="submit"
                                    variant="outlined"
                                    color="error"
                                    style={{ marginLeft: '15px', marginTop: '10px' }}
                                    onClick={() => deleteReport()}
                                >
                                    Delete
                                </Button>
                                <Button
                                    type="submit"
                                    variant="outlined"
                                    color="primary"
                                    style={{ marginLeft: '15px', marginTop: '10px' }}
                                    onClick={() => {
                                        toggleDeleteModal();
                                        setRowData();
                                    }}
                                >
                                    Cancel
                                </Button>
                            </div>
                           
                        </ModalBody>
                    </Modal>

                    {editModal && (
                        <EditModal
                            toggleEditModal={toggleEditModal}
                            editModal={editModal}
                            tableRowData={tableRowData && tableRowData}
                            setTableRowData={setTableRowData}
                            getReportList={getReportList}
                            generateReportId={generateReportId}
                        />
                    )}
                    
                </div>
            )}
        </React.Fragment>
    );
}

export default AccessAndManageReports;
